import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { putApi } from '../../apiUtils';
import { Loader } from '../../components/loader/Loader';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { TerminalMappingForm } from '../../forms/terminalMapping/TerminalMappingForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { DetailPageParams } from '../../types/pageParams.types';
import { TerminalMapping, TerminalMappingUpdateInput } from '../../types/terminalMapping.types';
import { API_URL, fetcher } from '../../utils/apiUrl';

export const TerminalMappingEdit = () => {
  const { translate } = useTranslation();
  const transFormName = 'TerminalMapping.Update';
  const { startLoading, stopLoading } = useLoading();
  const { setValue } = useBreadcrumbs();
  const { id } = useParams<DetailPageParams>();

  const [formData, setFormData] = useState<TerminalMappingUpdateInput>();

  const { data: terminalMapping } = useSWR<TerminalMapping>(
    `${API_URL.TERMINAL_MAPPING_ITEM}?id=${id}`,
    fetcher,
  );

  useEffect(() => {
    setValue({
      pageName: 'Edit terminal mapping',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Terminal mapping', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  useEffect(() => {
    if (!terminalMapping) return;

    setFormData({
      id: terminalMapping.id,
      ip: terminalMapping.ip,
      defaultUserId: terminalMapping.defaultUserId,
      assignedAssetId: terminalMapping.assignedAssetId,
      defaultAssetClass: terminalMapping.defaultAssetClass,
      description: terminalMapping.description,
    });
  }, [terminalMapping]);

  const onSubmit = async (e) => {
    if (e !== null) e.preventDefault();
    let isOk = false;
    startLoading();
    await putApi({
      url: API_URL.TERMINAL_MAPPING_UPDATE,
      data: formData,
      callAfterSuccess: () => {
        isOk = true;
      },
    });
    stopLoading();
    return isOk;
  };

  if (!formData) return <Loader />;

  return (
    <PageContentWrapper heading={translate!('Edit terminal mapping', transFormName)}>
      <TerminalMappingForm onSubmit={onSubmit} formData={formData} isEdit />
    </PageContentWrapper>
  );
};
